module.exports = __webpack_public_path__ + "img/TheGirls.e598eb79.svg";